import { isClient } from '~/utils/misc';
// eslint-disable-next-line no-restricted-imports
import { createClientLogger } from './client-logger';
import type { Logger } from './logger.interface';
// eslint-disable-next-line no-restricted-imports
import { createServerLogger } from './server-logger';

export const getLogger = (name: string, customerId?: string, hostname?: string): Logger =>
  isClient() ? createClientLogger(name) : createServerLogger(name, customerId, hostname);
